import Types from "./types";
import AssessmentServiceApi from "../../services/assessment-api";
import { createCookie, readCookie } from "../../utils/helpers";
import FunnelStepTypes from "../funnel-step/types";
import { toast } from "react-toastify";

const createUserAccount = (data, t) => {
  return function (dispatch) {
    return AssessmentServiceApi.createUser(data)
      .then((response) => {
        console.log({ response });
        if (response && response.isValid) {
          const authData = {
            Username: data.email.trim(),
            Password: data.password.trim(),
          };
          createCookie("userguid", response.userGuid, 1);
          return AssessmentServiceApi.AuthenticateUser(authData).then(
            (authResponse) => {
              const { jwtToken, refreshToken, expiresAt } = authResponse;
              localStorage.setItem("jwtToken", jwtToken);
              localStorage.setItem("refreshToken", refreshToken);
              localStorage.setItem("expiresAt", expiresAt);
              createCookie("jwtToken", jwtToken, 1);
              createCookie("refreshToken", refreshToken, 1);
              createCookie("expiresAt", expiresAt, 1);
              dispatch(
                PushUserInformationToFunnelStep({
                  userGUID: response.userGuid,
                  email: data.email,
                  gender: data.gender,
                  isPremium: response?.isPremium,
                })
              );
              return response;
            }
          );
        } else {
          return response;
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          const { ErrorData } = error.response.data;
          if (ErrorData?.UsernameAsPassword) {
            toast.error(t("account.usernamePasswordSame"));
          }
        } else {
          console.error("Unexpected Error:", error);
        }
        throw error; // rethrow for further upstream handling
      });
  };
};

const createExternalUserAccount = (data) => {
  return function (dispatch) {
    return AssessmentServiceApi.createExternalUser(data)
      .then((response) => {
        if (response && response.isValid) {
          const authData = {
            Username: data?.createUser?.email,
            email: data?.createUser?.email,
            userGuid: response.userGuid,
          };

          createCookie("userguid", response.userGuid, 1);
          return AssessmentServiceApi.AuthenticateExternalUser(authData)
            .then((authResponse) => {
              const { jwtToken, refreshToken, expiresAt } = authResponse;
              localStorage.setItem("jwtToken", jwtToken);
              localStorage.setItem("refreshToken", refreshToken);
              localStorage.setItem("expiresAt", expiresAt);
              createCookie("jwtToken", jwtToken, 1);
              createCookie("refreshToken", refreshToken, 1);
              createCookie("expiresAt", expiresAt, 1);
              dispatch(
                PushUserInformationToFunnelStep({
                  userGUID: response.userGuid,
                  email: data?.createUser?.email,
                  gender: data?.createUser?.gender,
                })
              );
              return response;
            })
            .catch((error) => {
              console.error("Error during authentication:", error);
              throw error;
            });
        } else {
          console.log("Invalid response, not proceeding:", response);
          return response;
        }
      })
      .catch((error) => {
        console.error("Error in createExternalUserAccount:", error);
        throw error;
      });
  };
};

const getContentLatestVersion = (data) => {
  return function () {
    return AssessmentServiceApi.getContentLatestVersion(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const createContentMap = (data) => {
  return function () {
    return AssessmentServiceApi.createContentMap(data)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const getAssessmentByAssessmentId = (id) => {
  return function () {
    return AssessmentServiceApi.getAssessmentByAssessmentId(id)
      .then((response) => {
        if (response) {
          return response;
        }
      })
      .catch((error) => console.log("Error"));
  };
};

const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});

export {
  createUserAccount,
  createExternalUserAccount,
  getContentLatestVersion,
  getAssessmentByAssessmentId,
  createContentMap,
};
